import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { Regex, translationConstants } from "../../../../../constants";
import { competitionActions } from "../../../../../redux/actions";
import { allowOnlyNumbers } from "../../../../../system";

const RefundForm = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm();

  const onSubmit = (data) => {
    const dataToSend = {
      competitionId: props.selectedUser?.competitionId,
      systemUserId: props.selectedUser?.systemUserId,
      amount: props.refundAmount,
      percentage: data.refundPercentage.slice(0, -1),
      comments: data.comments,
    };
    dispatch(
      competitionActions.refundPublicCompetition(dataToSend, () => {
        dispatch(
          competitionActions.getCompetitionTotalPaymentById(
            props?.selectedUser?.competitionId
          )
        );
      })
    );
    props.setShow(!props.show);
  };

  const refund = (percentage) => {
    if (percentage === "%") {
      setValue("refundPercentage", "");
    } else {
      const newValue = percentage.slice(0, -1);
      props.handleRefund(props.selectedUser?.fee, newValue, false);
    }
  };

  return (
    <section className="ViewUserContent px-3 my-5">
      <div className="ViewHeader">
        <p className="viewUserPara">{t(translationConstants.REFUND_FEES)}</p>
      </div>
      <p className="horizentalLine" />
      <div className="m-t-24">
        <Form
          noValidate
          className="ViewUserContent"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Form.Group className="form-group-register mt-2">
            <Form.Label className="Form-labels">
              {t(translationConstants.REFUND_PERCENTAGE)}:
            </Form.Label>
            <div className=" d-flex justify-content-center align-items-center">
              <Form.Control
                {...register("refundPercentage", {
                  required: t(translationConstants.INVALID_VALUE),
                  pattern: {
                    value: Regex.refundPercentageRegex,
                    message: t(translationConstants.INVALID_VALUE),
                  },
                })}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const cursorPosition = e.target.selectionStart; // Get cursor position
                  const newValue = inputValue.endsWith("%")
                    ? inputValue
                    : inputValue + "%"; // Append '%' only if not already present
                  setValue("refundPercentage", newValue, {
                    shouldValidate: true,
                  });
                  // Adjust cursor position if needed
                  if (cursorPosition === inputValue.length) {
                    e.target.selectionStart = e.target.selectionEnd =
                      newValue.length - 1; // Set cursor position before the '%'
                  } else {
                    e.target.selectionStart = e.target.selectionEnd =
                      cursorPosition; // Keep cursor position unchanged
                  }
                  trigger("refundPercentage");
                  refund(newValue);
                }}
                defaultValue={props.refundPercentage + "%"}
                id="refundPercentage"
                type="text"
                placeholder={t(translationConstants.ENTER_REFUND_PERCENTAGE)}
                onKeyDown={(e) => allowOnlyNumbers(e)}
              />
            </div>
            {errors?.refundPercentage && (
              <p className="errorText">{errors?.refundPercentage?.message}</p>
            )}
          </Form.Group>
          <Form.Group className="form-group-register mt-2">
            <Form.Label className="Form-labels">
              {t(translationConstants.REFUND_AMOUNT)}:
            </Form.Label>
            <div className="d-flex justify-content-center align-items-center">
              <Form.Control
                {...register("refundAmount", {})}
                value={props?.refundAmount}
                id="refundAmount"
                type="text"
                disabled={true}
              />
            </div>
          </Form.Group>
          <Form.Group className="form-group-register mt-2">
            <Form.Label className="Form-labels">
              {t(translationConstants.comments)}
            </Form.Label>
            <div className=" d-flex justify-content-center align-items-center">
              <Form.Control
                {...register("comments", {})}
                onChange={(e) => {
                  setValue("comments", e.target.value, {
                    shouldValidate: true,
                  });
                  trigger("comments");
                }}
                id="comments"
                as="textarea" // Changed to textarea
                rows={4}
                placeholder={t(translationConstants.ENTER_COMMENTS)}
              />
            </div>
          </Form.Group>
          <Button className="SubmitDocs-button" type="submit">
            {t(translationConstants.refund)}
          </Button>
        </Form>
      </div>
    </section>
  );
};

export default RefundForm;
